import React, { Component } from 'react'
import { connect } from 'react-redux'

// API
import * as API  from '../../../utils/api'

// Packages
import { Helmet } from 'react-helmet'

// Actions
import {
  getProfileAccountDetails
} from '../../../actions/accountDetails'

// Components
import Header from '../../../components/Global/Header'
import Footer from '../../../components/Global/Footer'
import AccountSettingsNav from '../../../components/UserPortal/AccountSettings/AccountSettingsNav'
import FormContainer from '../../../components/Global/FormContainer'
import AccountAdminsForm from '../../../components/Forms/AccountAdminsForm'
import FlashMessage from '../../../components/Global/FlashMessage'
import AppCanvasLoader from '../../../components/Global/AppCanvasLoader'

class AccountAdmins extends Component {
  state = {
    adminEmails: [],
    pendingAdminEmails: [],
    isLoading: true,
    flashMessage: {
      display: false,
      message: '',
    }
  }

  componentDidMount() {
    this.initializeAccountAdmins(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.initializeAccountAdmins(nextProps)
  }

  initializeAccountAdmins(props) {
    const { user, activeProfile } = props

    API.getProfileLevelAccountInfo(user, activeProfile.username).then(response => {
      this.prepopulateForm(response.account_admins)
    })
  }

  prepopulateForm(adminData) {
    let adminEmails = adminData.maintainer_emails
    let pendingAdminEmails = adminData.pending_invited_emails

    let emailsThatAreNotCurrentUser = adminEmails.filter((email) => {
      return email !== this.props.user.email
    })

    this.setState(state => ({
      ...state,
      adminEmails: emailsThatAreNotCurrentUser,
      pendingAdminEmails: pendingAdminEmails,
      isLoading: false
    }))
  }

  handleFormSubmit = (emails) => {
    const { user, activeProfile } = this.props

    let emailsForSubmit = [user.email, ...emails]

    API.updateMaintainerEmails(user, activeProfile.username, emailsForSubmit)
    .then(response => {
      if (response.errors) {
        console.log('there was an error: ', response.errors)
      } else {
        this.handleSuccessfulSubmit(response)
      }
    })
  }

  handleSuccessfulSubmit(response) {
    window.scrollTo(0, 0)
    let { pendingAdminEmails } = this.state

    let updatedAdminEmails = this.getUpdatedAdminEmails(response)
    let updatedPendingAdminEmails = [...pendingAdminEmails, ...response.invited_emails]

    let flashMessageText = "Your changes were saved successfully."

    flashMessageText = response.invited_emails.length > 0
      ? flashMessageText.concat(" Individuals that do not yet have a Locker Linked account have been emailed an invitation to join and will show in the 'Pending Admins' column until they accept the invitation.")
      : flashMessageText

    this.setState(({
      adminEmails: updatedAdminEmails,
      pendingAdminEmails: updatedPendingAdminEmails,
      flashMessage: {
        display: true,
        message: flashMessageText
      }
    }))
  }

  getUpdatedAdminEmails(submitResponse) {
    const { adminEmails } = this.state
    let emailsToRemove = [...submitResponse.removed_emails]
    let addedEmails = [...submitResponse.added_emails]

    let emailsPostRemoval = adminEmails.filter( function( email ) {
      return !emailsToRemove.includes( email )
    })

    let updatedAdminEmails = [...emailsPostRemoval, ...addedEmails]

    return updatedAdminEmails
  }

  renderSuccessFlashMessage() {
    const { flashMessage } = this.state

    return flashMessage.display
    ? (
      <FlashMessage>
        {flashMessage.message}
      </FlashMessage>
    ) : null
  }

  renderPendingAdminInfo() {
    let { pendingAdminEmails } = this.state

    return pendingAdminEmails.length > 0
    ? (
      <div className="pending-admin-info">
        <p>
          The following emails have been sent an invitation to join Locker Linked and become an account admin:
        </p>
        {pendingAdminEmails.map((email) => {
          return (
            <div key={email} className="pending-admin-info-email">
              {email}
            </div>
          )
        })}
      </div>
    )
    : (
      <div className="pending-admin-info">
        <p>
          There are currently no outstanding invitations to admins. For additional admins, add an email to the Account Admins form.
        </p>
      </div>
    )
  }

  render() {
    const { path, appName } = this.props
    let {
      adminEmails,
      isLoading,
    } = this.state

    return (
      <div className="user-portal account-settings account-admins">
        <Helmet>
          <title>{appName} | Settings – Account Admins</title>
        </Helmet>
        <Header path={ path } />
        <AccountSettingsNav currentTab="account-admins"  />
        <div className="account-admins-canvas inner-wrap">
          <FormContainer>
            <header>
              <h1>Account Admins</h1>
            </header>
            {this.renderSuccessFlashMessage()}
            <AccountAdminsForm
              adminEmails={adminEmails}
              isLoading={isLoading}
              handleSubmit={(input) => this.handleFormSubmit(input)}
              submitButtonText="Save Changes"
            />
          </FormContainer>
          <FormContainer>
            <header>
              <h2>Pending Admins</h2>
            </header>
            {isLoading ? <AppCanvasLoader/> : this.renderPendingAdminInfo()}
          </FormContainer>
        </div>
        <Footer appName={ appName } path={ path } />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getProfileAccountDetails: (user, athleteUsername) => {
      dispatch(getProfileAccountDetails(user, athleteUsername))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountAdmins)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Settings/AccountAdmins.js